(function () {
  const selector = '[data-transformium-slider]';
  const initialized = new WeakSet();
  const pendingButtons = new WeakSet();
  const moneyFormat = window.Shopify?.money_format || '₹{{amount}}';

  function getDependencies() {
    return Boolean(
      window.jQuery &&
      window.jQuery.fn &&
      typeof window.jQuery.fn.slick === 'function'
    );
  }

  function formatMoney(cents) {
    if (typeof window.Shopify?.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function initializeSlider(section) {
    if (initialized.has(section)) return;

    if (!getDependencies()) {
      window.setTimeout(function () {
        initializeSlider(section);
      }, 250);
      return;
    }

    initialized.add(section);

    const $section = window.jQuery(section);
    const tabs = Array.from(section.querySelectorAll('[data-collection-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-collection-panel]'));
    const modal = section.querySelector('[data-variant-modal]');
    const dialog = section.querySelector('[data-modal-dialog]');
    const modalImage = section.querySelector('[data-modal-image]');
    const modalTitle = section.querySelector('[data-modal-title]');
    const modalPrice = section.querySelector('[data-modal-price]');
    const modalComparePrice = section.querySelector('[data-modal-compare-price]');
    const modalOptions = section.querySelector('[data-modal-options]');
    const modalError = section.querySelector('[data-modal-error]');
    const modalSubmit = section.querySelector('[data-modal-submit]');
    const announcement = section.querySelector('[data-cart-announcement]');

    let activeButton = null;
    let selectedProduct = null;
    let selectedVariant = null;
    let lastFocusedElement = null;
    let requestController = null;
    let announcementTimer = null;

    function showAnnouncement(message, isError) {
      if (!announcement) return;

      announcement.textContent = message;
      announcement.classList.toggle('is-error', Boolean(isError));
      announcement.classList.add('is-visible');

      window.clearTimeout(announcementTimer);

      announcementTimer = window.setTimeout(function () {
        announcement.classList.remove('is-visible');
      }, 3500);
    }

    function updateProgress(panel) {
      const track = panel.querySelector('[data-product-slider]');
      const progress = panel.querySelector('[data-slider-progress] span');

      if (!track || !progress) return;

      const $track = window.jQuery(track);

      if (!$track.hasClass('slick-initialized')) return;

      const slick = $track.slick('getSlick');
      const total = Math.max(slick.slideCount - slick.options.slidesToShow, 0);
      const current = Math.min(slick.slickCurrentSlide(), total);
      const percentage = total === 0 ? 100 : ((current + 1) / (total + 1)) * 100;

      progress.style.width = percentage + '%';
    }

    function initializePanel(panel) {
      const track = panel.querySelector('[data-product-slider]');

      if (!track) return;

      const $track = window.jQuery(track);

      if ($track.hasClass('slick-initialized')) {
        $track.slick('setPosition');
        updateProgress(panel);
        return;
      }

      $track.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        adaptiveHeight: false,
        accessibility: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 1.35
            }
          }
        ]
      });

      $track.on('init reInit afterChange setPosition', function () {
        updateProgress(panel);
      });

      panel.querySelector('[data-slider-prev]')?.addEventListener('click', function () {
        $track.slick('slickPrev');
      });

      panel.querySelector('[data-slider-next]')?.addEventListener('click', function () {
        $track.slick('slickNext');
      });

      updateProgress(panel);
    }

    function activateTab(tab) {
      const targetId = tab.dataset.panel;

      tabs.forEach(function (item) {
        const active = item === tab;

        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach(function (panel) {
        const active = panel.id === targetId;

        panel.hidden = !active;
        panel.classList.toggle('is-active', active);

        if (active) initializePanel(panel);
      });
    }

    function setModalError(message) {
      if (!modalError) return;

      modalError.textContent = message || '';
      modalError.hidden = !message;
    }

    function getSelectedOptions() {
      return Array.from(modalOptions.querySelectorAll('[data-option-group]')).map(function (group) {
        const selected = group.querySelector('[data-option-value].is-selected');
        return selected ? selected.dataset.optionValue : null;
      });
    }

    function findMatchingVariant() {
      const values = getSelectedOptions();

      if (values.some(function (value) { return value === null; })) {
        return null;
      }

      return selectedProduct.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return String(option) === String(values[index]);
        });
      }) || null;
    }

    function updateSelectedVariant() {
      selectedVariant = findMatchingVariant();

      const available = Boolean(selectedVariant && selectedVariant.available);

      if (selectedVariant) {
        modalPrice.textContent = formatMoney(selectedVariant.price);

        if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
          modalComparePrice.textContent = formatMoney(selectedVariant.compare_at_price);
          modalComparePrice.hidden = false;
        } else {
          modalComparePrice.hidden = true;
        }

        if (selectedVariant.featured_image?.src) {
          modalImage.src = selectedVariant.featured_image.src;
        } else if (selectedVariant.featured_image) {
          modalImage.src = selectedVariant.featured_image;
        } else if (selectedProduct.featured_image) {
          modalImage.src = selectedProduct.featured_image;
        }
      } else {
        modalPrice.textContent = 'Unavailable';
        modalComparePrice.hidden = true;
      }

      modalSubmit.disabled = !available;
      modalSubmit.textContent = available ? 'Add to Cart' : 'Unavailable';

      modalOptions.querySelectorAll('[data-option-group]').forEach(function (group, groupIndex) {
        group.querySelectorAll('[data-option-value]').forEach(function (button) {
          const value = button.dataset.optionValue;
          const possible = selectedProduct.variants.some(function (variant) {
            return variant.available && String(variant.options[groupIndex]) === value &&
              variant.options.every(function (option, optionIndex) {
                if (optionIndex === groupIndex) return true;

                const otherGroup = modalOptions.querySelector('[data-option-group="' + optionIndex + '"]');
                const otherSelected = otherGroup?.querySelector('[data-option-value].is-selected');

                return !otherSelected || String(option) === otherSelected.dataset.optionValue;
              });
          });

          button.classList.toggle('is-unavailable', !possible);
          button.setAttribute('aria-disabled', String(!possible));
        });
      });

      setModalError('');
    }

    function renderOptions(product) {
  modalOptions.replaceChildren();

  const defaultVariant =
    product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0];

  product.options.forEach(function (option, index) {
    const values = Array.from(
      new Set(
        product.variants.map(function (variant) {
          return variant.options[index];
        })
      )
    );

    const group = document.createElement('div');
    group.className = 'transformium-variant-modal__option-group';
    group.dataset.optionGroup = String(index);

    const label = document.createElement('p');
    label.className = 'transformium-variant-modal__option-label';
    label.textContent = typeof option === 'string' ? option : option.name;

    group.appendChild(label);

    const valuesContainer = document.createElement('div');
    valuesContainer.className = 'transformium-variant-modal__values';

    values.forEach(function (value) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'transformium-variant-modal__option';
      button.dataset.optionValue = String(value);
      button.textContent = value;

      const isSelected =
        defaultVariant &&
        String(defaultVariant.options[index]) === String(value);

      button.classList.toggle('is-selected', Boolean(isSelected));
      button.setAttribute('aria-pressed', String(Boolean(isSelected)));

      button.addEventListener('click', function () {
        group.querySelectorAll('[data-option-value]').forEach(function (item) {
          const active = item === button;

          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-pressed', String(active));
        });

        updateSelectedVariant();
      });

      valuesContainer.appendChild(button);
    });

    group.appendChild(valuesContainer);
    modalOptions.appendChild(group);
  });

  updateSelectedVariant();
}

    function closeModal() {
      if (!modal || modal.hidden) return;

      modal.hidden = true;
      document.body.classList.remove('transformium-variant-modal-open');

      if (requestController) {
        requestController.abort();
        requestController = null;
      }

      if (lastFocusedElement?.isConnected) {
        lastFocusedElement.focus();
      }

      activeButton = null;
      selectedProduct = null;
      selectedVariant = null;
    }

    async function openModal(button) {
      if (!modal || pendingButtons.has(button)) return;

      lastFocusedElement = button;
      activeButton = button;
      selectedProduct = null;
      selectedVariant = null;

      modal.hidden = false;
      document.body.classList.add('transformium-variant-modal-open');
      modalTitle.textContent = button.dataset.productTitle || '';
      modalImage.removeAttribute('src');
      modalImage.alt = button.dataset.productTitle || '';
      modalPrice.textContent = 'Loading...';
      modalComparePrice.hidden = true;
      modalOptions.replaceChildren();
      modalSubmit.disabled = true;
      modalSubmit.textContent = 'Loading...';
      setModalError('');

      dialog.focus();

      if (requestController) requestController.abort();

      requestController = new AbortController();

      try {
        const productUrl = button.dataset.productUrl;

        if (!productUrl) {
          throw new Error('Product information is unavailable.');
        }

        const response = await fetch(productUrl.replace(/\/$/, '') + '.js', {
          headers: {
            Accept: 'application/json'
          },
          signal: requestController.signal
        });

        if (!response.ok) {
          throw new Error('Unable to load product options. Please try again.');
        }

        const product = await response.json();

        if (activeButton !== button || modal.hidden) return;

        selectedProduct = product;

        modalTitle.textContent = product.title;
        modalImage.alt = product.title;

        if (product.featured_image) {
          modalImage.src = product.featured_image;
        }

        renderOptions(product);

        if (product.variants.length === 1 && product.options.length === 1) {
          const optionButton = modalOptions.querySelector('[data-option-value]');

          if (optionButton) {
            optionButton.classList.add('is-selected');
            optionButton.setAttribute('aria-pressed', 'true');
            updateSelectedVariant();
          }
        }

        modalSubmit.textContent = 'Add to Cart';
      } catch (error) {
        if (error.name === 'AbortError') return;

        setModalError(error.message || 'Unable to load product options.');
        modalSubmit.textContent = 'Add to Cart';
      } finally {
        requestController = null;
      }
    }

    modal?.querySelectorAll('[data-modal-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (modal?.hidden) return;

      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (event.key === 'Tab' && dialog) {
        const focusable = Array.from(
          dialog.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), [tabindex="0"]')
        ).filter(function (element) {
          return !element.hidden && element.offsetParent !== null;
        });

        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function (event) {
        let nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex]);
      });
    });

    const activeTab = tabs.find(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    });

    if (activeTab) activateTab(activeTab);

    $section.on('click', '[data-add-to-cart]', function () {
      if (this.disabled || pendingButtons.has(this)) return;
      openModal(this);
    });

    modalSubmit?.addEventListener('click', async function () {
      if (!selectedVariant || !selectedVariant.available || !activeButton) return;

      const button = activeButton;

      if (pendingButtons.has(button)) return;

      pendingButtons.add(button);
      modalSubmit.disabled = true;
      modalSubmit.textContent = 'Adding...';
      setModalError('');

      try {
        const response = await fetch(
          (window.Shopify?.routes?.root || '/') + 'cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(selectedVariant.id),
                  quantity: 1
                }
              ]
            })
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message || 'Unable to add this variant to your cart.');
        }

        const addedVariantId = Number(selectedVariant.id);

        closeModal();

        showAnnouncement('Product added to cart.');

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              productVariantId: addedVariantId,
              quantity: 1,
              item: result
            }
          })
        );

        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              productVariantId: addedVariantId,
              quantity: 1,
              response: result
            }
          })
        );

        const cartResponse = await fetch(
          (window.Shopify?.routes?.root || '/') + 'cart.js',
          {
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (cartResponse.ok) {
          const cart = await cartResponse.json();

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                cart: cart
              }
            })
          );
        }
      } catch (error) {
        if (!modal.hidden) {
          setModalError(error.message || 'Something went wrong. Please try again.');
          modalSubmit.disabled = false;
          modalSubmit.textContent = 'Add to Cart';
        } else {
          showAnnouncement(error.message || 'Something went wrong. Please try again.', true);
        }
      } finally {
        pendingButtons.delete(button);
      }
    });
  }

  function initializeAll(root) {
    if (root.matches?.(selector)) initializeSlider(root);
    root.querySelectorAll?.(selector).forEach(initializeSlider);
  }

  function start() {
    initializeAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();